// Lightweight client logger. Keeps background failures observable without
// spamming users with toasts for non-critical fetches.
export function logError(scope, error) {
  const detail = error?.response?.data?.detail ?? error?.message ?? error;
  // eslint-disable-next-line no-console
  console.error(`[${scope}]`, detail);
}
